module.exports = " <div class=row> <div class=col-md-12> <div ng-include=\"'header-proposals'\"></div> </div> </div> <div class=\"row blanco\"> <div class=col-xs-12> <div ng-include=\"'proposals-list'\"></div> <div ng-include=\"'proposals-details'\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/extensionVisibility/projectFormulation/list/projectFormulationProposalsList.html
// module id = 628
// module chunks = 0